// src/components/CustomerSummary/components/SectionToolbar.jsx
// ============================================================================
// BLOCK CS.UI.1 — SectionToolbar
// ----------------------------------------------------------------------------
// PURPOSE
// - Standard header toolbar for a section card.
// - Buttons render ONLY when their handler is provided.
//   (Derived sections pass undefined handlers to hide controls.)
// ============================================================================

import React from 'react';

import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CloseIcon from '@mui/icons-material/Close';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function SectionToolbar(p) {
  const {
    title,
    locked,
    expanded,
    canMoveUp,
    canMoveDown,
    onToggleExpand,
    onToggleLock,
    onAuto,
    onClear,
    onMoveUp,
    onMoveDown,
  } = p;

  // ==========================================================================
  // BLOCK CS.UI.1.1 — Capability gating
  // --------------------------------------------------------------------------
  // If a handler is not provided, we hide the corresponding control.
  // This allows derived sections to remove lock/auto/clear without special UI.
  // ==========================================================================
  const canToggleLock = typeof onToggleLock === 'function';
  const canAuto = typeof onAuto === 'function';
  const canClear = typeof onClear === 'function';
  const canExpand = typeof onToggleExpand === 'function';

  return (
    <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
      <Stack direction="row" spacing={1} alignItems="center">
        {canExpand && (
          <IconButton size="small" onClick={onToggleExpand}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
          {title}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={0.5} alignItems="center">
        {canToggleLock && (
          <FormControlLabel
            sx={{ mr: 1 }}
            control={<Checkbox checked={Boolean(locked)} onChange={onToggleLock} />}
            label="Lock"
          />
        )}

        {canAuto && (
          <IconButton size="small" onClick={onAuto}>
            <AutoAwesomeIcon fontSize="small" />
          </IconButton>
        )}

        {canClear && (
          <IconButton size="small" onClick={onClear} disabled={Boolean(locked)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        )}

        <IconButton size="small" onClick={onMoveUp} disabled={!canMoveUp}>
          <KeyboardArrowUpIcon fontSize="small" />
        </IconButton>

        <IconButton size="small" onClick={onMoveDown} disabled={!canMoveDown}>
          <KeyboardArrowDownIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Stack>
  );
}
